/* clean-cutouts.js — swap studio product photos for transparent cutouts (pp.cutouts) so the product sits on
   pure white with a drop shadow that follows its outline. Map: window.CLEAN_CUTOUTS (filename -> asset url). */
(function () {
  'use strict';
  var MAP = window.CLEAN_CUTOUTS || {};
  var SEL = '.product__media img, .card__media img, .clean-card__media img, .clean-hero__tile img, .clean-details__media img, .thumbnail img, .fish-tier__img img, .fish-pill--thumb img, .fish-sticky-bar__thumb, .cart-item__media img, .cart-item__image, .cart-notification-product__image img, .predictive-search__image';
  function base(src) { try { return decodeURIComponent(new URL(src, location.href).pathname.split('/').pop()); } catch (e) { return ''; } }
  function swap(img) {
    if (img.dataset.cut) return;
    var url = MAP[base(img.getAttribute('src') || img.currentSrc || '')];
    img.dataset.cut = url ? '1' : '0';
    if (!url) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
    var frame = img.closest('.product__media, .card__media .media, .clean-card__media, .clean-hero__tile, .clean-details__media, .thumbnail, .fish-tier__img, .fish-pill--thumb, .cart-item__media, .cart-item__link');
    if (frame) frame.classList.add('is-cutout');
    img.classList.add('is-cutout-img');
  }
  function scan() { document.querySelectorAll(SEL).forEach(swap); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
